import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import * as actions from '../../Calado/actions'
import { renderRadioField } from '../../Forms/fieldRenderers'
import CalificacionesCondicion from './CalificacionesCondicion'
import { FORM_PROCESO_CALADO } from '../../../config/forms'
import { IconButton } from '@material-ui/core'
import { toast } from 'react-toastify'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const selector = formValueSelector(FORM_PROCESO_CALADO)

const modosIngreso = [
  { fieldName: 'A', name: 'Conforme' },
  { fieldName: 'C', name: 'Condicional' },
  { fieldName: 'R', name: 'Rechazo' }
]

const calleParaRechazos = 0

class CondicionIngreso extends Component {
  constructor (props) {
    super(props)
    this.onSelectModoIngreso = this.onSelectModoIngreso.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.updateCondicionIngreso = this.updateCondicionIngreso.bind(this)
    this.onSelectCondicionIngreso = this.onSelectCondicionIngreso.bind(this)
    this.changeForm = this.changeForm.bind(this)
    this.changeFormSegunda = this.changeFormSegunda.bind(this)
    this.state = { show: false }
    this.state = { viewSegundaCalificacion: false }
    this.state = { viewCalificacion: false }
    this.handleClick = this.handleClick.bind(this)
    this.closeSegundaCondicion = this.closeSegundaCondicion.bind(this)
  }

  componentDidUpdate () {
    const { cea, change: formChange } = this.props
    if (!this.state.viewSegundaCalificacion && cea && cea.claveCalificacionCerealDos) {
      formChange('condicionIngresoSegunda', cea.claveCalificacionCerealDos)
      this.setState({ viewSegundaCalificacion: true })
      this.setState({ show: !this.state.show })
    }

    if (!this.state.viewCalificacion && cea && cea.claveCalificacionCereal) {
      formChange('condicionIngreso', cea.claveCalificacionCereal)
      this.setState({ viewCalificacion: true })
    }
  }

  updateCondicionIngreso (newState) {
    this.props.updateCondicionIngreso(newState)
  }

  handleClick () {
    const {
      condicion
    } = this.props
    console.log(condicion)
    if (!this.state.show && condicion) {
      this.setState({ show: !this.state.show })
    } else {
      toast.error(`No puede agregar una condicion, porque no esta seleccionada la primera.`)
    }
  }

  closeSegundaCondicion () {
    const {
      change: formChange
    } = this.props
    formChange('condicionIngresoSegunda', null)
    this.setState({ show: false })
  }

  handleChange (e, selected) {
    this.props.onChange(selected)
    // this.onSelectCondicionIngreso()
  }

  changeForm (calificacion, e) {
    const {
      change: formChange
    } = this.props
    formChange('condicionIngreso', calificacion && calificacion)
    console.log('Nueva condicion de ingreso: ', calificacion)
  }

  changeFormSegunda (calificacion, e) {
    const {
      change: formChange,
      condicion
    } = this.props
    if (calificacion !== condicion) {
      formChange('condicionIngresoSegunda', calificacion && calificacion)
      console.log('Nueva condicion de ingreso: ', calificacion)
    } else {
      toast.error(`No puede seleccionar la misma calificación`)
      this.closeSegundaCondicion()
    }
  }

  componentDidMount () {
    const {
      setModoIngreso,
      modoIngreso,
      cea
    } = this.props
    if (modoIngreso && modoIngreso !== 'A') {
      setModoIngreso(cea['claveCereal'], cea['estadoCalificacion'])
    }
  }

  onSelectModoIngreso (modo) {
    const {
      setModoIngreso,
      cea,
      cpa,
      calle,
      requestCalleSugerida,
      onChange,
      change: formChange
    } = this.props
    const modoValue = modo
    setModoIngreso(cea['claveCereal'] || cpa.claveCereal, modoValue)
    this.closeSegundaCondicion()
    formChange('condicionIngreso', null)
    if (modo === 'R') {
      this.props.updatePendienteAutorizar(false)
      this.props.updateFumigado(false)
      this.props.updateSiloAparte(false)
      formChange('calle', calleParaRechazos && calleParaRechazos)
    } else if (modo !== 'R' && calle === calleParaRechazos) {
      requestCalleSugerida(cpa.claveCereal, (calle) => {
        formChange('calle', calle && calle.numero)
      })
    }
    onChange && onChange(modoValue)
  }

  onSelectCondicionIngreso (claveCondicionIngreso) {
    if (claveCondicionIngreso === 'CINFEC  ') {
      this.props.updateFumigado(true)
      this.props.updateSiloAparte(true)
      this.props.updatePendienteAutorizar(true)
    } else if (claveCondicionIngreso === 'CHDAD   ') {
      this.props.updatePendienteAutorizar(true)
    } else if (claveCondicionIngreso === 'CTUCULAN') {
      this.props.updateZarandeo(true)
      this.props.updatePendienteAutorizar(true)
      this.props.updateMotivoDeZarandeo('TUCULANG')
    }
  }

  render () {
    const {
      calificaciones,
      modoIngreso,
      condicionInicial,
      condicionInicialDos
    } = this.props

    return (
      <div className='modo-ingreso'>
        <Field
          onChange={this.onSelectModoIngreso}
          name='modoIngreso'
          className='calificaciones-ingreso'
          options={modosIngreso}
          style={{ marginBottom: '165px' }}
          component={renderRadioField} />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignContent: 'center' }}>
          <div style={{ width: '90%' }}>
            <CalificacionesCondicion
              calificaciones={calificaciones}
              condicionInicial={condicionInicial}
              onSelectCondicionIngreso={this.onSelectCondicionIngreso}
              changeForm={this.changeForm}
            />
          </div>
          {(!this.state.show && modoIngreso !== 'A') && <IconButton style={{ float: 'rigth', padding: '0', color: 'rgba(0, 0, 0, 0.54)', outline: 'none' }} onClick={this.handleClick}><ExpandMoreIcon /></IconButton> }
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '3%' }}>
          <div style={{ width: '90%' }}>
            {this.state.show && <CalificacionesCondicion
              calificaciones={calificaciones}
              condicionInicial={condicionInicialDos}
              onSelectCondicionIngreso={this.onSelectCondicionIngreso}
              changeForm={this.changeFormSegunda}
            />
            }
          </div>
          {(this.state.show && modoIngreso !== 'A') && <IconButton style={{ float: 'rigth', padding: '0', color: 'rgba(0, 0, 0, 0.54)', outline: 'none' }} onClick={this.closeSegundaCondicion}><ExpandLessIcon /></IconButton> }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  cea: state.calado.consultaCea || {},
  cpa: state.camionesIngreso.consultaCpa,
  condicion: selector(state, 'condicionIngreso'),
  segundaCondicion: selector(state, 'condicionIngresoSegunda'),
  modoIngreso: selector(state, 'modoIngreso'),
  calificaciones: state.calado.calificaciones,
  condicionInicial: (state.calado.consultaCea) ? state.calado.consultaCea.calificacionCereal : null,
  condicionInicialDos: (state.calado.consultaCea) ? state.calado.consultaCea.calificacionCerealDos : null,
  calle: selector(state, 'calle')
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PROCESO_CALADO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(CondicionIngreso))
